<i18n src="../../locales/lang.json"></i18n>
<template>
  <div>
    <modal-three-buttons v-bind:title="$t('invite_user')" v-bind:button3text="$t('send_invitations')" v-bind:button2text="customizetext" ref="thisModal" v-bind:onsave_button2="isCustomizeSet" v-bind:onsave_button3="doInvite" v-bind:size="size">
      <div class="container-fluid">
        <div class="col-12" style="max-height:calc(100vh - 150px);overflow-y:auto">
          <div v-bind:class="customizeClass">
            <div class="row mt-3 mb-3">
              <div class="col-11 px-0">
                <button type="button" @click="copy" class="btn btn-light col-12"><i class="icon-link mt-1 pull-left"></i>{{$t('copy_url')}}</button>
              </div>
              <div class="col-1 pl-1">
                <qr-invite-button ref="qrbutton" class="" style="line-height:35px;"></qr-invite-button>
              </div>
              <div class="col-12 mt-1 text-center custom-form-label" v-show="confirmCopy == true">
                <label class="custom-form-label">{{$t('copied_to_clipboard')}}</label>
              </div>
            </div>
            <div v-for="(email,index) in emails" class="row mt-1">
              <div class="col-11 px-0">
                <input v-model="email.email" v-bind:placeholder="$t('enter_email')" type="email" class="form-control" name="email" v-bind:id="'txt_email_' +  getId()">
              </div>
              <div class="col-1 pl-1"><a href="#" @click="deleteEmail(index)" style="color: inherit;"><i style="font-size: 20px; color: inherit; margin-top: 8px" class="fa fa-trash-o"></i></a></div>
            </div>
            <div class="row mt-3">
              <div class="col-12">
                <a href="#" @click="addEmailControl" style="color: inherit">+ {{$t('add_another')}}</a>
              </div>
            </div>
          </div>
          <div class="pb-3 col-12 col-md-9 pull-left" v-show="isCustomize">
            <mail-editor-user templatetype="1" @event-apply-email-template="emailtemplateCall"></mail-editor-user>
          </div>
        </div>
      </div>
     
    </modal-three-buttons>
  </div>
</template>

<script>
  import MailEditor from '../mail/mail-editor.vue'
  import ModalDefault from "../modals/modal-default.vue";
  import ModalThreeButton from "../modals/modal-three-buttons.vue";
  export default {
    name: "team-registration-invite-new",
    components: {
      ModalDefault,
      MailEditor,
      ModalThreeButton,
    },
    props: {
    },
    data() {
      return {
        teamId: -1,
        emails: [],
        index: 0,
        link: '',
        siteUniqueId: '',
        confirmCopy: false,
        qrlink: null,
        emailtemplate: null,
        isCustomize: false,
        customizetext: this.$t('customize'),
        size: '',
        customizeClass:'col-12 pull-left'
      };
    },
    methods: {
      isCustomizeSet() {
        this.customizetext = this.isCustomize ? this.$t('customize') : this.$t('not_customize');
        this.isCustomize = !this.isCustomize;
        this.customizeClass = this.isCustomize ? 'pb-3 p-0 pr-md-4 col-12 col-md-3 pull-left' : 'col-12 pull-left';
        this.size = this.isCustomize ? 'modal-xl' : '';       
        this.$forceUpdate();
      },
      emailtemplateCall(emailtemplate) {       
        this.emailtemplate = emailtemplate;
        console.log(this.emailtemplate);
      },
      copy_old() {
        this.$refs.clone.focus();
        document.execCommand('copy');
      },

      copy() {
        const el = document.createElement('textarea');
        el.value = this.link;
        el.setAttribute('readonly', 'false');
        el.contentEditable = true;
        el.style.position = 'absolute';
        el.style.left = '-9999px';

        document.body.appendChild(el);
        /*
        const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        if (selected) {
          document.getSelection().removeAllRanges();
          document.getSelection().addRange(selected);
        }
*/
        /*
        https://stackoverflow.com/questions/34045777/copy-to-clipboard-using-javascript-in-ios
        */
        var range = document.createRange();
        var s = window.getSelection();
        s.removeAllRanges();
        s.addRange(range);

        el.setSelectionRange(0, 999999); // A big number, to cover anything that could be inside the element.

        document.execCommand('copy');

        this.confirmCopy = true;
      },
      addEmailControl() {
        this.emails.push({ id: this.index, email: '' });
        this.index++;
        Vue.set(this, "emails", this.emails)
        this.$forceUpdate();
      },
      deleteEmail(index) {
        this.emails.splice(index, 1);
        console.log(this.emails);
        Vue.set(this, "emails", this.emails);
        this.$forceUpdate();
      },
      getId() {
        return this._uid;
      },

      getSiteUniqueId() {
        try {
          var url = '/api/Sites/v1/detail';
          this.$http.get(url).then(async response => {
            var data = response.data;
            this.siteUniqueId = data.UniqueId;
            this.$forceUpdate();
          });
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },

      open(teamId) {
        this.emails = [];
        this.index = 0;
        this.$refs.thisModal.open();
        this.emails.push({ id: this.index, email: '' });
        Vue.set(this, "emails", this.emails)
        this.index++;
        this.teamId = teamId;

        this.$refs.qrbutton.lang = this.$store.getLocale()
        if (this.teamId > 0) {
          this.$refs.qrbutton.teamid = '' + this.teamId;
          this.link = window.location.origin + '/link/' + this.siteUniqueId + '/register/' + this.teamId + '?lang=' + this.$store.getLocale();
        } else {
          this.$refs.qrbutton.teamid = null;
          this.link = window.location.origin + '/link/' + this.siteUniqueId + '/register' + '?lang=' + this.$store.getLocale();
        }
        this.$forceUpdate();
      },

      async doInvite() {
        var mails = [];
        this.emails.forEach((item, index) => {
          mails.push(item.email);
        });
        var request = {
          emails: mails,
          link: this.link,
          mailTemplate: this.emailtemplate
        };

        ///api/Procedure/ScheduleProcedure
        try {
          var response = this.$http.post(
            '/api/team/SendInvitation',
            request
          ).then(async response => {
            this.$refs.thisModal.close();
          });
        } catch (err) {
          alert(err);
        }

      },

    },
    computed: {

    },
    watch: {

    },
    mounted() {
      this.getSiteUniqueId();
    },
    created() {

    },
  };

</script>
<style scoped>
  
</style>



// WEBPACK FOOTER //
// src/components/team/team-registration-invite-new.vue